/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Not_ReceivedInputs */

const en_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't see the email? Check your spam folder or <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>try again</button>.`)
};

const id_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak melihat email tersebut? Periksa folder spam atau <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>coba lagi</button>.`)
};

const ms_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak melihat e-mel? Semak folder spam anda atau <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>cuba lagi</button>.`)
};

const ca_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No veus cap correu? Comprova la teva carpeta de correu brossa o <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>torna-ho a intentar</button>.`)
};

const cs_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail vám nepřišel? Zkontrolujte složku s nevyžádanou poštou (spam) nebo to <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>zkuste znovu</button>.`)
};

const da_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan du ikke se e-mailen? Tjek din spam-mappe, eller <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>prøv igen</button>.`)
};

const de_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast die E-Mail nicht erhalten? Überprüfe deinen Spam-Ordner oder klicke auf <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>Erneut versuchen</button>.`)
};

const et_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei näe e-kirja? Kontrollige oma rämpsposti kausta või <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>proovige uuesti</button>.`)
};

const es_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No recibiste el correo? Revisa tu carpeta de correo no deseado o <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>vuelve a intentarlo</button>.`)
};

const fr_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n’avez pas reçu l’e-mail ? Pensez à vérifier le dossier spam ou <button id=’try-again’ class=’hover:text-60 text-text-interactive underline’ type=’button’>réessayez</button>.`)
};

const hr_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne vidite e-mail? Provjerite spam ili <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>pokušajte ponovno</button>.`)
};

const it_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non trovi l'email? Controlla la tua cartella di spam o <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>riprova</button>.`)
};

const lv_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neredzat e-pasta ziņojumu? Pārbaudiet surogātpasta mapi vai <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>mēģiniet vēlreiz</button>.`)
};

const lt_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nematote el. laiško? Patikrinkite brukalo aplanką arba <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>bandykite dar kartą</button>.`)
};

const hu_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem látja az e-mailt? Ellenőrizze a spam mappát, vagy <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>próbálja meg újra</button>.`)
};

const nl_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vind je de e-mail niet? Controleer de map met ongewenste e-mail of <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>probeer het opnieuw</button>.`)
};

const nb_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finner du ikke e-posten? Sjekk søppelpostmappen din eller <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>prøv igjen</button>.`)
};

const pl_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie widzisz wiadomości e-mail? Sprawdź folder spamu lub <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>spróbuj ponownie</button>.`)
};

const pt_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não encontrou o e-mail? Verifique sua pasta de spam ou <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>tente novamente</button>.`)
};

const ro_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu vezi email-ul? Verifică folderul spam sau <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>încearcă din nou</button>.`)
};

const sk_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nevidíte email? Skontrolujte priečinok s nevyžiadanou poštou alebo to <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>skúste znova</button>.`)
};

const sl_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne vidite e-poštnega sporočila? Preverite mapo za neželeno pošto ali <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>poskusite znova</button>.`)
};

const fi_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkö näe sähköpostia? Tarkista roskapostikansiosi tai <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>yritä uudelleen</button>.`)
};

const sv_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ser du inte e-postmeddelandet? Kontrollera din skräppostmapp eller <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>försök igen</button>.`)
};

const vi_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thấy email? Hãy kiểm tra thư mục thư rác hoặc <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>thử lại</button>.`)
};

const tr_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postayı görmüyor musunuz? Spam klasörünüzü kontrol edin veya <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>tekrar deneyin</button>.`)
};

const el_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν βλέπετε το email; Ελέγξτε τον φάκελο ανεπιθύμητης αλληλογραφίας ή <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>δοκιμάστε ξανά</button>.`)
};

const bg_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не виждаш имейла? Провери папката си за спам или <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>опитай отново</button>.`)
};

const ru_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не видите письмо? Проверьте папку со спамом или <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>попробуйте еще раз</button>.`)
};

const sr_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не видите имејл? Проверите фолдер за нежељену пошту или <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>пробајте поново</button>.`)
};

const uk_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не бачите листа? Перевірте папку "Спам" або <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>спробуйте ще раз</button>.`)
};

const ka_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`არ მიიღეთ მეილი? შეამოწმეთ სპამის საქაღალდე ან <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>სცადეთ ხელახლა</button>.`)
};

const hi_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल नहीं दिख रहा है? अपना स्पैम फोल्डर चेक करें या <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>ट्राई अगेन</button>।`)
};

const th_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่เห็นอีเมลใช่ไหม ตรวจสอบในโฟลเดอร์สแปมหรือ<button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>ลองอีกครั้ง</button>`)
};

const ko_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일이 보이지 않나요? 스팸 폴더를 확인하거나 <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>다시 시도하세요</button>.`)
};

const zh_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有看到电子邮件？请检查您的垃圾邮件文件夹，或<button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>再试一次</button>。`)
};

const zh_tw_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看不到電子郵件？請檢查您的垃圾郵件或<button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>再試一次</button>。`)
};

const ja_email_not_received = /** @type {(inputs: Email_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールが見当たりませんか？ 迷惑メールフォルダをチェックするか、<button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>もう一度お試し</button>ください。`)
};

/**
* | output |
* | --- |
* | "Don't see the email? Check your spam folder or <button id='try-again' class='hover:text-60 text-text-interactive underline' type='button'>try again</button>." |
*
* @param {Email_Not_ReceivedInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const email_not_received = /** @type {((inputs?: Email_Not_ReceivedInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Not_ReceivedInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_email_not_received(inputs)
	if (locale === "ms") return ms_email_not_received(inputs)
	if (locale === "ca") return ca_email_not_received(inputs)
	if (locale === "cs") return cs_email_not_received(inputs)
	if (locale === "da") return da_email_not_received(inputs)
	if (locale === "de") return de_email_not_received(inputs)
	if (locale === "et") return et_email_not_received(inputs)
	if (locale === "es") return es_email_not_received(inputs)
	if (locale === "fr") return fr_email_not_received(inputs)
	if (locale === "hr") return hr_email_not_received(inputs)
	if (locale === "it") return it_email_not_received(inputs)
	if (locale === "lv") return lv_email_not_received(inputs)
	if (locale === "lt") return lt_email_not_received(inputs)
	if (locale === "hu") return hu_email_not_received(inputs)
	if (locale === "nl") return nl_email_not_received(inputs)
	if (locale === "nb") return nb_email_not_received(inputs)
	if (locale === "pl") return pl_email_not_received(inputs)
	if (locale === "pt") return pt_email_not_received(inputs)
	if (locale === "ro") return ro_email_not_received(inputs)
	if (locale === "sk") return sk_email_not_received(inputs)
	if (locale === "sl") return sl_email_not_received(inputs)
	if (locale === "fi") return fi_email_not_received(inputs)
	if (locale === "sv") return sv_email_not_received(inputs)
	if (locale === "vi") return vi_email_not_received(inputs)
	if (locale === "tr") return tr_email_not_received(inputs)
	if (locale === "el") return el_email_not_received(inputs)
	if (locale === "bg") return bg_email_not_received(inputs)
	if (locale === "ru") return ru_email_not_received(inputs)
	if (locale === "sr") return sr_email_not_received(inputs)
	if (locale === "uk") return uk_email_not_received(inputs)
	if (locale === "ka") return ka_email_not_received(inputs)
	if (locale === "hi") return hi_email_not_received(inputs)
	if (locale === "th") return th_email_not_received(inputs)
	if (locale === "ko") return ko_email_not_received(inputs)
	if (locale === "zh") return zh_email_not_received(inputs)
	if (locale === "zh-tw") return zh_tw_email_not_received(inputs)
	if (locale === "ja") return ja_email_not_received(inputs)
	return en_email_not_received(inputs)
});